import { getCampaignRun } from '../../services/api';

export const POLL_MS = 2000;
export const POLL_MAX_MS = 120000;

// Polls a run until phase === 'done'. A run can finish with a non-done phase and needsAttention (LINE was updated but
// saving failed; the server completes it on its own), so give up after ~2 minutes with { timedOut: true }.
export async function waitForRun(runId, { isCancelled = () => false, intervalMs = POLL_MS, maxMs = POLL_MAX_MS } = {}) {
  const started = Date.now();
  let run = null;
  while (!isCancelled()) {
    try {
      run = await getCampaignRun(runId);
      if (run.phase === 'done') return { run, timedOut: false };
    } catch (e) { /* transient poll error: keep trying until the deadline */ }
    if (Date.now() - started >= maxMs) return { run, timedOut: true };
    await new Promise((r) => setTimeout(r, intervalMs));
  }
  return { run, timedOut: false, cancelled: true };
}

export const ATTENTION_MSG = "Check the channel's aliases and default menu";
